import { render, staticRenderFns } from "./JSuperQuery.vue?vue&type=template&id=013df73a&scoped=true&"
import script from "./JSuperQuery.vue?vue&type=script&lang=js&"
export * from "./JSuperQuery.vue?vue&type=script&lang=js&"
import style0 from "./JSuperQuery.vue?vue&type=style&index=0&id=013df73a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013df73a",
  null
  
)

export default component.exports